import CustomersSummaryProvider from './CustomersSummaryContext';
import CustomersSummary from './CustomersSummary';

let Index = () => {
    return (
        <CustomersSummaryProvider>
            <CustomersSummary />
        </CustomersSummaryProvider>
    )
}

export default Index;